export default "__VITE_ASSET__BLeOZhh8__"